import {
  ADDRESSES_PAGE,
  BANK_ACCOUNTS_PAGE,
  BUY_PAGE,
  FINANCIAL_BALANCES_PAGE,
  INSIDER_PLUS_PAGE,
  METAL_STREAM_PAGE,
  SELL_PAGE,
  STATEMENTS_PAGE,
  USER_MANAGEMENT_PAGE,
  CREDIT_CARDS_PAGE,
} from './pages';
import { INSIDER_PLUS_APP_PATHS } from './insiderPlusAppPaths';
import i18next from '../i18n';
import config from '../config';

const { metalStreamCaption } = config;

export const tradingNavItems = [
  {
    id: 1,
    name: i18next.t('header.linkBuy'),
    href: BUY_PAGE,
    dataCyDropdownItem: 'nav-buy',
  },
  {
    id: 2,
    name: i18next.t('header.linkSell'),
    href: SELL_PAGE,
    dataCyDropdownItem: 'nav-sell',
  },
  {
    id: 3,
    name: i18next.t('header.linkMetalStream', {
      metalStream: metalStreamCaption,
    }),
    href: METAL_STREAM_PAGE,
    dataCyDropdownItem: 'nav-metal-stream',
  },
];

export const accountNavItems = [
  // [Insider+] Membership entry — filtered out by Header.js when the user
  // has no active Insider+ subscription.
  {
    id: 1,
    name: i18next.t('header.linkInsiderPlusMembership'),
    href: '/insider-plus-membership',
    dataCyDropdownItem: 'nav-insider-plus-membership',
  },
  {
    id: 2,
    name: i18next.t('header.linkBalances'),
    href: FINANCIAL_BALANCES_PAGE,
    dataCyDropdownItem: 'nav-balances',
  },
  {
    id: 3,
    name: i18next.t('header.linkStatements'),
    href: STATEMENTS_PAGE,
    dataCyDropdownItem: 'nav-statements',
  },
  {
    id: 4,
    name: i18next.t('header.linkBankAccounts'),
    href: BANK_ACCOUNTS_PAGE,
    dataCyDropdownItem: 'nav-bank-accounts',
  },
  {
    id: 5,
    name: i18next.t('header.linkCreditCards'),
    href: CREDIT_CARDS_PAGE,
    dataCyDropdownItem: 'nav-credit-cards',
  },
  {
    id: 6,
    name: i18next.t('header.linkAddresses'),
    href: ADDRESSES_PAGE,
    dataCyDropdownItem: 'nav-addresses',
  },
  {
    id: 7,
    name: i18next.t('header.linkUsers'),
    href: USER_MANAGEMENT_PAGE,
    dataCyDropdownItem: 'nav-users',
  },
];

// [Insider+] Subscriber-only dropdown links into insider-plus module routes —
// only rendered in Header.js when hasInsiderPlus is true.
export const insiderPlusNavItems = [
  {
    id: 1,
    name: i18next.t('header.linkInsiderPlusMembersHub'),
    href: `${INSIDER_PLUS_PAGE}${INSIDER_PLUS_APP_PATHS.welcome}`,
    dataCyDropdownItem: 'nav-insider-plus-welcome',
  },
  {
    id: 2,
    name: i18next.t('header.linkInsiderPlusMarketInsights'),
    href: `${INSIDER_PLUS_PAGE}${INSIDER_PLUS_APP_PATHS.indicators}`,
    dataCyDropdownItem: 'nav-insider-plus-indicators',
  },
  {
    id: 3,
    name: i18next.t('header.linkInsiderPlusExpertSessions'),
    href: `${INSIDER_PLUS_PAGE}${INSIDER_PLUS_APP_PATHS.webinars}`,
    dataCyDropdownItem: 'nav-insider-plus-webinars',
  },
  {
    id: 4,
    name: i18next.t('header.linkInsiderPlusInvestorBriefing'),
    href: `${INSIDER_PLUS_PAGE}${INSIDER_PLUS_APP_PATHS.newsletters}`,
    dataCyDropdownItem: 'nav-insider-plus-newsletters',
  },
  {
    id: 5,
    name: i18next.t('header.linkInsiderPlusMetalsPlaybook'),
    href: `${INSIDER_PLUS_PAGE}${INSIDER_PLUS_APP_PATHS.metalsPlaybookCourse}`,
    dataCyDropdownItem: 'nav-insider-plus-metals-playbook',
  },
  {
    id: 6,
    name: i18next.t('header.linkInsiderPlusCommunity'),
    href: `${INSIDER_PLUS_PAGE}${INSIDER_PLUS_APP_PATHS.forum}`,
    dataCyDropdownItem: 'nav-insider-plus-community',
  },
];

export const closedAccountNavItems = [
  {
    id: 1,
    name: i18next.t('header.linkBalances'),
    href: FINANCIAL_BALANCES_PAGE,
    dataCyDropdownItem: 'nav-balances',
  },
  {
    id: 2,
    name: i18next.t('header.linkStatements'),
    href: STATEMENTS_PAGE,
    dataCyDropdownItem: 'nav-statements',
  },
];
export const basicAccountTradingNavItems = [
  {
    id: 1,
    name: i18next.t('header.linkBuy'),
    href: BUY_PAGE,
    dataCyDropdownItem: 'nav-buy',
  },
];
export const basicAccountNavItems = [
  {
    id: 1,
    name: i18next.t('header.linkAddresses'),
    href: ADDRESSES_PAGE,
    dataCyDropdownItem: 'nav-addresses',
  },
];
